import { translate } from "application/functions";
import { toast } from "react-toastify";

export default function showToast() {
  toast.warn(translate("query-error"), {
    toastId: "toast",
  });
}
